import { useState, useEffect, memo } from "react";

function ClockWidget() {
  const [time, setTime] = useState(() => new Date());

  useEffect(() => {
    const interval = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(interval);
  }, []);

  const fmt = (n) => String(n).padStart(2, "0");
  const h = fmt(time.getHours());
  const m = fmt(time.getMinutes());
  const s = fmt(time.getSeconds());

  return (
    <div className="fixed bottom-6 left-6 z-50 font-mono text-[10px] uppercase tracking-[0.2em] text-white/25 hidden md:flex items-center gap-3 pointer-events-none select-none">
      <span className="w-1.5 h-1.5 rounded-full bg-green-400 pulse-dot" />
      <span>{h}:{m}:{s}</span>
      <span className="text-white/10">|</span>
      <span>{time.toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric" })}</span>
    </div>
  );
}

export default memo(ClockWidget);
